import { combineReducers } from "redux";
import {
  PRICE_GET_LOADING,
  PRICE_GET_ERROR,
  PRICE_GET_SUCCESS,
  PRICE_VIEW_ERROR,
  PRICE_VIEW_LOADING,
  PRICE_VIEW_SUCCESS,
  PRICE_ADD_ERROR,
  PRICE_ADD_LOADING,
  PRICE_ADD_SUCCESS,
  PRICE_DELETE_ERROR,
  PRICE_DELETE_LOADING,
  PRICE_DELETE_SUCCESS,
  PRICE_EDIT_SUCCESS,
  UPLOAD_DOKUMEN_PENETAPAN_TARIF_ERROR,
  UPLOAD_DOKUMEN_PENETAPAN_TARIF_LOADING,
  UPLOAD_DOKUMEN_PENETAPAN_TARIF_SUCCESS,
  PRICE_HISTORY_LOADING,
  PRICE_HISTORY_ERROR,
  PRICE_HISTORY_SUCCESS,
  PRICE_DEPO_HISTORY_LOADING,
  PRICE_DEPO_HISTORY_ERROR,
  PRICE_DEPO_HISTORY_SUCCESS,
  PRICE_SHIPPER_HISTORY_LOADING,
  PRICE_SHIPPER_HISTORY_ERROR,
  PRICE_SHIPPER_HISTORY_SUCCESS,
} from "../actions/constant";

const priceGetError = (state = false, action) => {
  switch (action.type) {
    case PRICE_GET_ERROR:
      return action.priceGetError;
    default:
      return state;
  }
};

const priceGetLoading = (state = false, action) => {
  switch (action.type) {
    case PRICE_GET_LOADING:
      return action.priceGetLoading;
    default:
      return state;
  }
};

const priceGetSuccess = (state = false, action) => {
  switch (action.type) {
    case PRICE_GET_SUCCESS:
      return action.priceGetSuccess;
    default:
      return state;
  }
};

const prices = (state = [], action) => {
  switch (action.type) {
    case PRICE_GET_SUCCESS:
      return action.prices;
    default:
      return state;
  }
};

const priceViewLoading = (state = false, action) => {
  switch (action.type) {
    case PRICE_VIEW_LOADING:
      return action.priceViewLoading;
    default:
      return state;
  }
};

const priceViewError = (state = false, action) => {
  switch (action.type) {
    case PRICE_VIEW_ERROR:
      return action.priceViewError;
    default:
      return state;
  }
};

const priceViewSuccess = (state = false, action) => {
  switch (action.type) {
    case PRICE_VIEW_SUCCESS:
      return action.priceViewSuccess;
    default:
      return state;
  }
};

const price = (state = [], action) => {
  switch (action.type) {
    case PRICE_VIEW_SUCCESS:
      return action.price;
    case PRICE_ADD_SUCCESS:
      return action.price;
    default:
      return state;
  }
};

const priceHistoryLoading = (state = false, action) => {
  switch (action.type) {
    case PRICE_HISTORY_LOADING:
      return action.priceHistoryLoading;
    default:
      return state;
  }
};

const priceHistoryError = (state = false, action) => {
  switch (action.type) {
    case PRICE_HISTORY_ERROR:
      return action.priceHistoryError;
    default:
      return state;
  }
};

const priceHistorySuccess = (state = false, action) => {
  switch (action.type) {
    case PRICE_HISTORY_SUCCESS:
      return action.priceHistorySuccess;
    default:
      return state;
  }
};

const priceHis = (state = [], action) => {
  switch (action.type) {
    case PRICE_HISTORY_SUCCESS:
      return action.priceHis;
    default:
      return state;
  }
};

const priceDepoHistoryLoading = (state = false, action) => {
  switch (action.type) {
    case PRICE_DEPO_HISTORY_LOADING:
      return action.priceDepoHistoryLoading;
    default:
      return state;
  }
};

const priceDepoHistoryError = (state = false, action) => {
  switch (action.type) {
    case PRICE_DEPO_HISTORY_ERROR:
      return action.priceDepoHistoryError;
    default:
      return state;
  }
};

const priceDepoHistorySuccess = (state = false, action) => {
  switch (action.type) {
    case PRICE_DEPO_HISTORY_SUCCESS:
      return action.priceDepoHistorySuccess;
    default:
      return state;
  }
};

const priceDepoHis = (state = [], action) => {
  switch (action.type) {
    case PRICE_DEPO_HISTORY_SUCCESS:
      return action.priceDepoHis;
    default:
      return state;
  }
};

const priceShipperHistoryLoading = (state = false, action) => {
  switch (action.type) {
    case PRICE_SHIPPER_HISTORY_LOADING:
      return action.priceShipperHistoryLoading;
    default:
      return state;
  }
};

const priceShipperHistoryError = (state = false, action) => {
  switch (action.type) {
    case PRICE_SHIPPER_HISTORY_ERROR:
      return action.priceShipperHistoryError;
    default:
      return state;
  }
};

const priceShipperHistorySuccess = (state = false, action) => {
  switch (action.type) {
    case PRICE_SHIPPER_HISTORY_SUCCESS:
      return action.priceSHipperHistorySuccess;
    default:
      return state;
  }
};

const priceShipperHis = (state = [], action) => {
  switch (action.type) {
    case PRICE_SHIPPER_HISTORY_SUCCESS:
      return action.priceShipperHis;
    default:
      return state;
  }
};

const priceAddError = (state = false, action) => {
  switch (action.type) {
    case PRICE_ADD_ERROR:
      return action.priceAddError;
    default:
      return state;
  }
};

const priceAddLoading = (state = false, action) => {
  switch (action.type) {
    case PRICE_ADD_LOADING:
      return action.priceAddLoading;
    default:
      return state;
  }
};

const priceAddSuccess = (state = false, action) => {
  switch (action.type) {
    case PRICE_ADD_SUCCESS:
      return action.priceAddSuccess;
    default:
      return state;
  }
};

const priceDeleteError = (state = false, action) => {
  switch (action.type) {
    case PRICE_DELETE_ERROR:
      return action.priceDeleteError;
    default:
      return state;
  }
};

const priceDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case PRICE_DELETE_LOADING:
      return action.priceDeleteLoading;
    default:
      return state;
  }
};

const priceDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case PRICE_DELETE_SUCCESS:
      return action.priceDeleteSuccess;
    default:
      return state;
  }
};
const priceEditSuccess = (state = false, action) => {
  switch (action.type) {
    case PRICE_EDIT_SUCCESS:
      return action.priceEdit;
    default:
      return state;
  }
};

const uploadDokumenPenetapanTarif = (state = [], action) => {
  switch (action.type) {
    case uploadDokumenPenetapanTarifSuccess:
      return action.uploadDokumenPenetapanTarif;
    default:
      return state;
  }
};

const uploadDokumenPenetapanTarifError = (state = false, action) => {
  switch (action.type) {
    case UPLOAD_DOKUMEN_PENETAPAN_TARIF_ERROR:
      return action.uploadDokumenPenetapanTarifError;
    default:
      return state;
  }
};

const uploadDokumenPenetapanTarifLoading = (state = false, action) => {
  switch (action.type) {
    case UPLOAD_DOKUMEN_PENETAPAN_TARIF_LOADING:
      return action.uploadDokumenPenetapanTarifLoading;
    default:
      return state;
  }
};

const uploadDokumenPenetapanTarifSuccess = (state = false, action) => {
  switch (action.type) {
    case UPLOAD_DOKUMEN_PENETAPAN_TARIF_SUCCESS:
      return action.uploadDokumenPenetapanTarifSuccess;
    default:
      return state;
  }
};

const priceReducer = combineReducers({
  priceGetError,
  priceGetLoading,
  priceGetSuccess,
  prices,

  priceViewLoading,
  priceViewError,
  priceViewSuccess,
  price,

  priceAddError,
  priceAddLoading,
  priceAddSuccess,

  priceDeleteError,
  priceDeleteLoading,
  priceDeleteSuccess,
  priceEditSuccess,

  uploadDokumenPenetapanTarif,
  uploadDokumenPenetapanTarifError,
  uploadDokumenPenetapanTarifLoading,
  uploadDokumenPenetapanTarifSuccess,

  priceHistorySuccess,
  priceHistoryLoading,
  priceHistoryError,
  priceHis,

  priceDepoHistorySuccess,
  priceDepoHistoryError,
  priceDepoHistoryLoading,
  priceDepoHis,

  priceShipperHistoryError,
  priceShipperHistoryLoading,
  priceShipperHistorySuccess,
  priceShipperHis,
});

export default priceReducer;
